import { render, staticRenderFns } from "./LogbookRecord.vue?vue&type=template&id=0e7f8b3b&scoped=true"
import script from "./LogbookRecord.vue?vue&type=script&lang=ts"
export * from "./LogbookRecord.vue?vue&type=script&lang=ts"
import style0 from "./LogbookRecord.vue?vue&type=style&index=0&id=0e7f8b3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7f8b3b",
  null
  
)

export default component.exports